import { cn } from '@/lib/cn';

// DESIGN-SYSTEM SS2.4 — colour is never the sole signal for state; each
// tone pairs its colour with an icon glyph and text, not colour alone.
const tones = {
  error: { classes: 'border-state-error text-state-error', glyph: '⚠' },
  success: { classes: 'border-state-success text-state-success', glyph: '✓' },
  info: { classes: 'border-border text-text-muted', glyph: 'ⓘ' },
} as const;

export function FormMessage({ tone, children }: { tone: keyof typeof tones; children: string }) {
  const { classes, glyph } = tones[tone];
  return (
    <p role={tone === 'error' ? 'alert' : 'status'} className={cn('rounded-sm border p-3 text-sm', classes)}>
      <span aria-hidden="true">{glyph}</span> {children}
    </p>
  );
}
